import { EChartsOption } from "echarts";

interface TrackerChartBuilder {
  setTitle(title: string): void;
  getTrackerEchartsOptions(): EChartsOption;
  setData(data: TrackcerData): void;
}

export interface TooltipFormatter {
  (value: number): string;
}

export type TrackcerData = (
  | {
      value: number;
      name: string;
      title: {
        color: string;
        offsetCenter: string[];
      };
      itemStyle: {
        color: string;
      };
      detail: {
        backgroundColor: string;
        color: string;
      };
    }
  | {
      value: number;
      name: string;
      title: any;
      itemStyle: any;
      detail: any;
    }
)[];

export class ConcreteTrackerChartBuilder implements TrackerChartBuilder {
  private options: EChartsOption = {};

  constructor() {
    this.reset();
  }

  public reset(): void {
    this.options = defaultTrackerOptions;
  }

  public setTitle(title?: string): void {
    this.options.title = {
      text: title,
      ...this.options.title,
    };
  }

  public getTrackerEchartsOptions(): EChartsOption {
    const result = this.options;
    this.reset();
    return result;
  }

  public setData(data: TrackcerData): void {
    if (Array.isArray(this.options.series) && this.options.series.length > 0)
      this.options.series[0].data = data;
  }
}

const defaultTrackerOptions: EChartsOption = {
  backgroundColor: "transparent",
  tooltip: {
    show: true,
    formatter: function (params: any) {
        return `${params?.name} <br />Ângulo: ${params?.value.toFixed(2)}°`;
    },
  },
  series: [
    {
      type: "gauge",
      pointer: {
        icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
        length: "12%",
        width: 10,
        offsetCenter: [0, "-55%"],
      },
      progress: {
        show: false,
        overlap: true,
        roundCap: true,
      },
      axisLine: {
        roundCap: true,
      },
      max: 45,
      min: -45,
      title: {
        fontSize: 14,
      },
      detail: {
        width: 40,
        height: 14,
        fontSize: 14,
        color: "#fff",
        backgroundColor: "inherit",
        borderRadius: 3,
        formatter: "{value}°",
      },
      colorBy: "data",
      axisLabel: {
        formatter: function (value: any) {
          return `${value.toFixed(0)}°`;
        },
      },
    },
  ],
};
